import {Subject, Subscription} from 'rxjs';

export class Subscribable {

  onDestroy = new Subject<boolean>();
  timerSubscriptions: Subscription[] = [];
  imageSubscriptions: Map<string, Subscription[]> = new Map<string, Subscription[]>();
  subscriptions: Subscription[] = [];

  pushSub(s: Subscription): void {
    this.subscriptions.push(s);
  }

  pushImageSub(key: string, s: Subscription): void {
    const existingSubs = this.imageSubscriptions.get(key);
    if (existingSubs) {
      existingSubs.push(s);
    } else {
      this.imageSubscriptions.set(key, [s]);
    }
  }

  pushTimerSub(s: Subscription): void {
    this.timerSubscriptions.push(s);
  }

  destroySubs(): void {
    this.subscriptions?.forEach(subscription => subscription.unsubscribe());
    this.subscriptions = [];
  }

  destroyImageSubs(): void {
    this.imageSubscriptions.forEach((val) => {
      val.forEach(subscription => subscription.unsubscribe());
    });
  }

  destroyImageSub(key: string): void {
    const sub = this.imageSubscriptions.get(key);
    if (!!sub) {
      sub.forEach(subscription => subscription.unsubscribe());
      this.imageSubscriptions.delete(key);
    }
  }

  destroy(): void {
    this.onDestroy.next(true);
    this.destroySubs();
    this.destroyImageSubs();
    this.destroyAllTimerSubs();
  }

  destroyAllTimerSubs(): void {
    this.timerSubscriptions.forEach(t => t.unsubscribe());
  }

}
